// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@tps/App/GoogleAnalyticsConnector/Store/Reducers";
import "@tps/App/Store/Reducers";
import "@tps/XDL";

// eslint-disable-next-line spire/fenced-imports
import { loadEditorTemplates } from "@insite/shell-public/EditorTemplatesLoader";

// // this registers any custom editor templates that are used by custom pages/widgets
// const templates = require.context("./App/EditorTemplates", true, /\.tsx$/);
// const onHotTemplateReplace = loadEditorTemplates(templates);
// if (module.hot) {
//     module.hot.accept(templates.id, () => {
//         onHotTemplateReplace(require.context("./App/EditorTemplates", true, /\.tsx$/));
//     });
// }

/**
 * Google Analytics Integration
 * Step: To enable Google Analytics, add the code below to your start.tsx file
 */

// Load all widgets. Without this, they won't be included in the bundle.
const GoogleAnalyticsWidgets = require.context("./App/GoogleAnalyticsConnector/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onGoogleAnalyticsHotWidgetReplace = addWidgetsFromContext(GoogleAnalyticsWidgets);

// Ensure HMR works for custom widgets.
if (module.hot) {
    module.hot.accept(GoogleAnalyticsWidgets.id, () =>
        onGoogleAnalyticsHotWidgetReplace(require.context("./App/GoogleAnalyticsConnector/Widgets", true, /\.tsx$/)),
    );
}

const googleAnalyticsHandlers = require.context("./App/GoogleAnalyticsConnector/Handlers", true);
googleAnalyticsHandlers.keys().forEach(key => googleAnalyticsHandlers(key));
/**
 * End Google Analytics Integration
 */

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./App/Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./App/Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// Load all the extensions to the base components. This includes style extensions.
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

// Load all the extensions to the base pages. This includes style extensions.
const pagesExtensions = require.context("./App/PageExtensions", true);
pagesExtensions.keys().forEach(key => pagesExtensions(key));
